import { Component, forwardRef, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TeamForAdmin, TeamMemberForAdmin } from '../team';
import { LoggerService } from '@teammood/shared/util/logger';
import { AdminSearchService, FeatureToggle } from './admin-search.service';
import { ActivatedRoute, Router } from "@angular/router";
import { filter, from, mergeMap, Subject, takeUntil } from "rxjs";


@Component({
    selector: 'admin-search',
    templateUrl: './admin-search.component.html',
    providers: [
        forwardRef(() => AdminSearchService)
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminSearchComponent implements OnInit, OnDestroy {
    query: string;
    teams: TeamForAdmin[];
    team_members: TeamMemberForAdmin[];
    featureToggles: FeatureToggle[];
    features: string[];

    private _destroy$ = new Subject<void>();

    constructor(
        private logger: LoggerService,
        private adminSearchService: AdminSearchService,
        private route: ActivatedRoute,
        private router: Router,
    ) {}

    async ngOnInit() {
        await this._loadFeatureToggles();

        this.route.queryParams.pipe(
            filter(params => params.query),
            mergeMap(params => {
                const query = params.query;
                return from(this.search(query));
            }),
            takeUntil(this._destroy$),
        ).subscribe();
    }

    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    async search(query: string) {
        this.query = query;
        await this.router.navigate(['/admin/search'], { queryParams:{query: query} });

        try {
            const response = await this.adminSearchService.do_admin_search(query);
            this.teams = response.teams;
            this.team_members = response.members;
        }catch (error) {
            this.logger.error(error.data);
        }
    }

    reload() {
        this.search(this.query);
    }

    private async _loadFeatureToggles() {
        this.featureToggles = await this.adminSearchService.getFeaturesToggles();
        this.features = this.featureToggles.map(feature => feature.feature);
    }

}